import { FilterTimeStep, FilterDirection, FilterSelfReview, FilterTimePeriod, type FilterParams } from '../types'
import { getDatesFromPeriod } from './period-options'

export const defaultTimePeriod = FilterTimePeriod.Week // Last 7 days
export const defaultFilterDirection = FilterDirection.Received

const mainDashboardDefaultParams = {
  decimals: 0,
  workspaceIds: [],
  timePeriod: defaultTimePeriod,
  userGroups: [],
  userIds: [],
  connectionIds: [],
  ratingCategoryTags: [],
  commentTags: [],
  ticketTags: [],
  helpdesksCustomFilters: [],
  ticketDates: false,
  step: FilterTimeStep.Day,
  direction: defaultFilterDirection,
  selfReview: FilterSelfReview.Exclude,
}

export const getDefaultParams = (extraParams?: Partial<FilterParams>): FilterParams => {
  const { fromDate, toDate } = getDatesFromPeriod({ timePeriod: defaultTimePeriod })
  return {
    ...mainDashboardDefaultParams,
    fromDate,
    toDate,
    categoryId: undefined,
    channels: [],
    ...extraParams,
  }
}
